import { useEffect, useRef, useState } from "react";
import { useQuizContext } from "./QuizContext";
import { subscribe } from "klaviyo-subscribe";
import { Loading } from "./Loading";
import { Markdown } from "@/snippets/globals/layout/Markdown";
import { ArrowLeft } from "@/snippets/icons/ArrowLeft";

export function QuizMailGate() {
  const form = useRef();
  const email = useRef();
  const context = useQuizContext();
  const { quizSettings, quizData, updateQuizData } = context;
  const [messages, setMessages] = useState([]);
  const [messagesToPrint, setMessagesToPrint] = useState(() => {
    const messages = [];

    if(!!quizSettings.mailGateSettings?.message1) {
      messages.push(quizSettings.mailGateSettings?.message1);
    }
    if(!!quizSettings.mailGateSettings?.message2) {
      messages.push(quizSettings.mailGateSettings?.message2);
    }

    return messages;
  });
  const [hasError, setHasError] = useState(false);
  const [loading, setLoading] = useState(true);

  const quizSubscribe = async (e) => {
    e.preventDefault();
    const results = quizData.answers.filter((answer) => answer);
    const parsedResults = results.map((result) => {
      if(result) {
        return `${result.questionIndex}:${Array.isArray(result.answer) ? result.answer.join(',') : result.answer}`
      }
    })
    const currentSearchParams = new URLSearchParams('step=results');
    parsedResults.forEach((result) => {
      currentSearchParams.append('responses', result)
    })
    await subscribe(
      quizSettings.mailGateSettings.mailGateKlaviyoId,
      document.querySelector('input[name="quiz-email"]').value,
      {
        quizResponseUrl: `${document.location.host}${document.location.pathname}?${currentSearchParams.toString()}`
      }
    ).then(( response ) => {
      const { success } = response;
      if(success === true) {
        updateQuizData({
          quizStep: 'results',
        })
      } else {
        setHasError(true);
      }
    });
  };

  useEffect(() => {
    setTimeout(() => {
      if(messages.length < messagesToPrint.length) {
        setMessages(messagesToPrint.slice(0, messages.length + 1));
        if(messages.length + 1 === messagesToPrint.length) {
          setLoading(false);
        }
      }
    }, 2000)

  }, [messages]);

  return (
    <>
      <div className="quiz-mail-gate__container mx-auto w-full max-w-2xl px-5">
      <div className="quiz-steps__back-button w-full pt-3 lg:pt-6">
        {quizData.currentQuestion > 0 && (
          <button
            type="button"
            className="flex items-center font-gothamBold"
            onClick={() => {
              updateQuizData({
                quizStep: "steps",
                hasError: false,
              })
            }}
          >
            <ArrowLeft className="leading-none" />
            <span className="ml-2 inline-block">Back</span>
          </button>
        )}
      </div>
        <div className="quiz-mail-gate__body-content mt-3 lg:mt-6 mb-10 flex min-h-[540px] flex-col rounded-[20px] border border-grey-4 px-4 py-5 lg:px-12 lg:py-8">
          {messages.length > 0 &&
            messages.map((message, index) => {
              return (
                <div
                  key={`message-${index}`}
                  className="mb-5 max-w-[80%] rounded-[20px] rounded-bl-none bg-primary-2 px-4 pt-3 pb-4 text-white"
                >
                  <Markdown content={message} />
                </div>
              );
            })}
          {loading && <Loading />}
          {!loading && messages.length === messagesToPrint.length && (
            <>
              <form
                className="mail-gate__form"
                ref={form}
                id="subscribeForm"
                onSubmit={quizSubscribe}
              >
                <input
                  type="email"
                  name="quiz-email"
                  placeholder="Mail Address"
                  label="Mail Address"
                  ref={email}
                  className="border-grey-5 placeholder-black border w-full py-2 px-4"
                  onChange={() => {
                    if(hasError) {
                      setHasError(false);
                    }
                  }}
                />
                {hasError && (
                  <p className="text-error text-left">There has been an error with your submission, please try again</p>
                )}
              </form>
              <div className="quiz-mail-gate__footer mt-auto w-full">
                <div className="text-center">
                  <button
                    className="underline font-gothamBold mx-auto mb-4 underline-offset-[6px]"
                    onClick={() => {
                      updateQuizData({
                        quizStep: 'results',
                      });
                    }}
                  >
                    {quizSettings.mailGateSettings.mailGateCTAText}
                  </button>
                </div>
                <button
                  type="submit"
                  className="button button--primary w-full"
                  form="subscribeForm"
                >
                  {quizSettings.mailGateSettings.mailGateSubmitText || 'submit'}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}